import React, { useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { useState } from "react";

mapboxgl.accessToken =
    "pk.eyJ1IjoiYWJoaWppdGgxMjc5IiwiYSI6ImNtNGNqdzE4NDA2MGoyaXFwdXh6cjVqMWQifQ.OpRKi-Zt3NIOjXFz-hd-DA";


const CountyComponent = () => {
    const mapContainerRef = useRef(null);
    const mapRef = useRef(null);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [selectedCounty, setSelectedCounty] = useState("North Carolina");
    const [showVacantOnly, setShowVacantOnly] = useState(false);
    const [showListedSaleOnly, setShowListedSaleOnly] = useState(false);
    const popupRef = useRef(null);


    const FLOOD_ZONE_LEGEND = [

        { zone: "X", color: "#4CAF50", label: "X - Minimal Risk" },
        { zone: "AE", color: "#FF9800", label: "AE - High Risk + BFE" },
        { zone: "VE", color: "#E91E63", label: "VE - Coastal + BFE" },
        { zone: "A", color: "#2196F3", label: "A - High Risk (No BFE)" },
        { zone: "null", color: "#9fa2e7", label: "Unknown" },



    ];
    const COUNTY_CENTERS = {
        "North Carolina": [-78.6443, 35.7877],
        wake: [-78.6382, 35.7796],
        chatham: [-79.4622, 35.7235],
    };


    useEffect(() => {
        mapRef.current = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: "mapbox://styles/mapbox/light-v11",
            //   center: [-82.5929, 28.8917],
            //   zoom: 10,
            //center: [-78.6443, 35.7877], // North Carolina approx center
            center: COUNTY_CENTERS["North Carolina"],
            zoom: 9,
        });

        mapRef.current.on("load", async () => {
            try {
                // const res = await fetch(
                //     //"/assets/parcel/northcarolina_custom_parcels_floodhazard.geojson"
                //     "/assets/parcel/county_northcarolina_parcels.geojson"

                // );
                // const geojson = await res.json();

                // const uniqueCounties = new Set(
                //     geojson.features.map(f => f.properties.county)
                // );
                // console.log("COUNTIES IN DATA:", [...uniqueCounties]);

                // const uniquelistedSale = new Set(
                //     geojson.features.map(f => f.properties.listedsale)
                // );
                // console.log("listed sale IN DATA:", [...uniquelistedSale]);

                // const nullCountyRecords = geojson.features.filter(
                //     (f) => f.properties?.county === null
                // );

                // console.log("COUNTY = NULL RECORDS:", nullCountyRecords);
                // console.log("TOTAL NULL COUNT:", nullCountyRecords.length);
                // mapRef.current.addSource("parcels", {
                //     type: "geojson",
                //     data: geojson,
                // });

                 mapRef.current.addSource('parcels', {
                        type: 'vector',
                        tiles: ["http://localhost:8080/data/carolina/{z}/{x}/{y}.pbf"],
                        // tiles: ["https://demo.flowlogic.com/tilesgl/data/fullparcel/{z}/{x}/{y}.pbf"],
                });

                mapRef.current.addLayer({
                    id: "parcel-fill",
                    type: "fill",
                    source: "parcels",
                    'source-layer': 'fema',
                    paint: {
                        "fill-color": [
                            "match",
                            ["get", "parcelcustomfemaflood"],
                            "X", "#4CAF50",
                            "AE", "#FF9800",
                            "VE", "#E91E63",
                            "A", "#2196F3",
                            "#9fa2e7",
                        ],
                        "fill-opacity": 0.45,
                    },
                });

                // mapRef.current.addLayer({
                //     id: "parcel-outline",
                //     type: "line",
                //     source: "parcels",
                //     paint: {
                //         "line-color": [
                //             "match",
                //             ["get", "parcelcustomfemaflood"],
                //             "X", "#4CAF50",
                //             "AE", "#FF9800",
                //             "VE", "#E91E63",
                //             "A", "#2196F3",
                //             "#9fa2e7",
                //         ],
                //         "line-width": 1.3,
                //     },
                // });

                //  mark map as fully ready
                setMapLoaded(true);

                mapRef.current.on("click", "parcel-fill", (e) => {
                    const feature = e.features[0];
                    if (!feature) return;

                    const props = feature.properties;

                    // REMOVE OLD POPUP
                    if (popupRef.current) {
                        popupRef.current.remove();
                    }

                    // CREATE NEW POPUP CONTENT
                    const popupHTML = `
                         <div style="
                background:#fff;
                padding:14px;
                border-radius:8px;
                box-shadow:0 2px 8px rgba(0,0,0,0.15);
                font-family:Inter, sans-serif;
                font-size:13px;
                width:260px;">
                
                <h3 style="margin:0 0 6px 0; color:#1565C0; font-size:15px;">
                  ${props.addrline1 || "N/A"}, ${props.city || ""},  ${props.county || ""}, ${props.state || ""} ${props.zip5 || ""}
                </h3>
                
                <hr style="border:none; border-top:1px solid #eee; margin:8px 0;">
                
                 <p><strong>Parcel id:</strong>  ${props.id ? `${props.id} ` : "N/A"}</p>
                 
                 <p><strong>Flood Fema Risk:</strong> ${props.floodfemarisk ? `${props.floodfemarisk} ` : "N/A"}</p>
                <p><strong>Parcel Size:</strong> ${props.parcelsize || "N/A"}</p>
                <p><strong>Zoning:</strong>  ${props.parcelcustomfemaflood ? `${props.parcelcustomfemaflood} ` : "N/A"}</p>
                
              </div>
                        `;

                    //  CREATE POPUP
                    popupRef.current = new mapboxgl.Popup({
                        closeButton: true,
                        closeOnClick: false,
                    })
                        .setLngLat(e.lngLat)
                        .setHTML(popupHTML)
                        .addTo(mapRef.current);
                });

            } catch (error) {
                console.error("Error loading GeoJSON:", error);
            }
        });


        return () => mapRef.current.remove();
    }, []);

    
    useEffect(() => {
        if (!mapLoaded || !mapRef.current) return;

        const map = mapRef.current;
        if (!map.getLayer("parcel-fill")) return;

        const center = COUNTY_CENTERS[selectedCounty];

        map.flyTo({
            center,
            zoom: selectedCounty === "North Carolina" ? 9 : 11,
            essential: true,
        });

        let filters = [];

        // COUNTY FILTER 
        if (selectedCounty !== "North Carolina") {
            filters.push(["==", ["get", "county"], selectedCounty]);
        }

        // VACANT FILTER
        if (showVacantOnly) {
            filters.push(["==", ["get", "is_vaccant"], 1]);
        }

        // LISTED SALE FILTER (active + pending ONLY)
        if (showListedSaleOnly) {
            filters.push([
                "any",
                ["==", ["get", "listedsale"], "ActiveListing"],
                ["==", ["get", "listedsale"], "PendingSale"]
            ]);
        }

        // APPLY FINAL FILTER
        if (filters.length === 0) {
            map.setFilter("parcel-fill", null);
        } else {
            map.setFilter("parcel-fill", ["all", ...filters]);
        }

    }, [
        selectedCounty,
        showVacantOnly,
        showListedSaleOnly,
        mapLoaded
    ]);




    return (
        <>
            <div
                style={{
                    position: "absolute",
                    top: "30px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 1000,
                    background: "#fff",
                    padding: "10px 16px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                    fontSize: "13px",
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                }}
            >
                {/*  COUNTY DROPDOWN */}
                <select
                    value={selectedCounty}
                    onChange={(e) => setSelectedCounty(e.target.value)}
                    style={{
                        padding: "6px 10px",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                        fontSize: "13px",
                        cursor: "pointer",
                    }}
                >
                    <option value="North Carolina">All North Carolina</option>
                    <option value="wake">Wake County</option>
                    <option value="chatham">Chatham County</option>
                </select>

                {/* VACANT CHECKBOX */}
                <label style={{ display: "flex", alignItems: "center", gap: "6px", fontWeight: "normal" }}>
                    <input
                        type="checkbox"
                        checked={showVacantOnly}
                        onChange={(e) => setShowVacantOnly(e.target.checked)}
                    />
                    Vacant Only
                </label>

                {/*  LISTED SALE CHECKBOX */}
                <label style={{ display: "flex", alignItems: "center", gap: "6px", fontWeight: "normal" }}>
                    <input
                        type="checkbox"
                        checked={showListedSaleOnly}
                        onChange={(e) => setShowListedSaleOnly(e.target.checked)}
                    />
                    Listed Sale
                </label>
            </div>

            <div
                ref={mapContainerRef}
                style={{ width: "100%", height: "100vh" }}
            />
            {/*FLOOD ZONE LEGEND - Bottom Center */}
            <div
                style={{
                    position: "absolute",
                    bottom: "10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    background: "rgba(255, 255, 255, 0.95)",
                    padding: "5px 5px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.25)",
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px",
                    zIndex: 1000,
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                }}
            >
                <span
                    style={{
                        fontWeight: "600",
                        color: "#333",
                        fontSize: "13px",
                        marginRight: "5px",
                    }}
                >
                    FloodZone:
                </span>
                {FLOOD_ZONE_LEGEND.map((item) => (
                    <div
                        key={item.zone}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                        }}
                    >
                        <div
                            style={{
                                width: "18px",
                                height: "18px",
                                backgroundColor: item.color,
                                opacity: 0.50,
                                borderRadius: "3px",
                                border: `2px solid ${item.color}`,
                            }}
                        />
                        <span style={{ color: "#555", fontSize: "11px", whiteSpace: "nowrap" }}>
                            {item.label}
                        </span>
                    </div>
                ))}
            </div>
        </>
    );
};

export default CountyComponent;
